import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import UserContext from "../../context/user";
import dayjs from "dayjs";

const useGetOsteopathAvailabilities = (selectedOsteopath) => {
  const { userProfile, callApi } = useContext(UserContext);

  const today = dayjs();

  return useQuery(
    ["availabilities", selectedOsteopath],
    () =>
      callApi(
        `/osteopath/${selectedOsteopath}/availabilities?${new URLSearchParams({
          dateFrom: today.format("DD-MM-YYYY"),
          dateTo: today.add(1, "year").format("DD-MM-YYYY"),
        }).toString()}`
      ),
    {
      enabled: !!userProfile && !!selectedOsteopath,
      select: (data) =>
        data
          ?.filter((item) => item.bookingAvailable)
          ?.map((date) => dayjs(Number(date.date)))
          ?.sort((a, b) => (a.isBefore(b) ? -1 : a.isAfter(b) ? 1 : 0)),
    }
  );
};

export default useGetOsteopathAvailabilities;
